import * as actionTypes from './actionTypes';

export const resetSecurityThreatsState = () => {
  return {
    type: actionTypes.RESET_SECURITY_THREATS_STATE,
    
  };
}
export const getSecurityThreatsStart = () => {
  return {
    type: actionTypes.GET_SECURITY_THREATS_START,
    
  };
}


export const getAdvancedSecurityThreats = (payload, isClicked) => {
  return {
    type: actionTypes.GET_ADVANCED_SECURITY_THREATS,
    pageNumber: payload && payload.pageNumber ? payload.pageNumber : 1,
    maxDaysOld: payload && payload.maxDaysOld ? payload.maxDaysOld : 1,
    size: payload && payload.size ? payload.size : 10,
    refreshData: payload && payload.refreshData ? payload.refreshData : false,
    isClicked: isClicked
  }
}

export const initSecurityLogInfo = () => {
  return{
    type: actionTypes.INIT_SECURITY_LOG_INFO

  }
}
export const setSecurityLogInfo = (info) => {
  // console.log('SETTING SECIIII')

  return {
    type: actionTypes.SET_SECURITY_LOG_INFO,
    securityLogInfo : info

  }
}

export const setAdvancedSecurityThreats = (securityThreats) => {
  return {
    type: actionTypes.SET_ADVANCED_SECURITY_THREATS,
    securityThreats : securityThreats

  }
}

export const setAdvancedSecurityThreatsSuccess = () => {
  return {
    type: actionTypes.SET_ADVANCED_SECURITY_THREATS_SUCCESS
  };
}

export const setAdvancedSecurityThreatsFailed = () => {
  return {
    type: actionTypes.SET_ADVANCED_SECURITY_THREATS_FAILED
  };
}

export const setAdvancedSecurityThreatsRefreshEnable = () => {
  return {
    type: actionTypes.SET_ADVANCED_SECURITY_THREATS_REFRESH
  };
}


